import { ref as v, defineComponent as C, watch as _, openBlock as g, createElementBlock as f, createElementVNode as i, toDisplayString as k, unref as w, createCommentVNode as I } from "vue";
function E(c) {
  const m = v(!1), o = v(null), x = (a) => new Promise((p, l) => {
    const n = new FileReader();
    n.readAsDataURL(a), n.onload = (h) => {
      var y;
      const d = (y = h.target) == null ? void 0 : y.result;
      if (typeof d != "string")
        return l("檔案讀取失敗：結果不是字串");
      const u = new Image();
      u.src = d, u.onload = () => {
        const t = document.createElement("canvas");
        t.width = 600, t.height = 800;
        const e = t.getContext("2d");
        if (!e)
          return l("瀏覽器不支援 Canvas");
        e.drawImage(u, 0, 0, 600, 800), t.toBlob(
          (r) => {
            r ? p(r) : l("圖片格式轉換失敗 (Blob Error)");
          },
          "image/jpeg",
          0.8
          // 品質設定為 80%
        );
      }, u.onerror = () => l("圖片載入失敗");
    }, n.onerror = () => l("檔案讀取發生錯誤");
  });
  return {
    uploadProcess: async (a, p) => {
      m.value = !0, o.value = null;
      try {
        const l = await x(a), n = await c.getUploadTicket(a.name, p);
        return await c.putToR2(n.uploadUrl, l), n.publicUrl;
      } catch (l) {
        return o.value = l.message || "上傳失敗", null;
      } finally {
        m.value = !1;
      }
    },
    isUploading: m,
    uploadError: o
  };
}
const $ = { class: "border-2 border-dashed border-gray-100 rounded-2xl p-6 text-center" }, S = { class: "mb-2 text-gray-500 text-xs font-mono" }, B = { class: "text-gray-400 text-xs mt-1" }, P = {
  key: 1,
  class: "relative group"
}, V = ["src"], A = {
  key: 2,
  class: "mt-4 text-blue-700 animate-pulse font-bold text-sm"
}, D = {
  key: 3,
  class: "mt-2 text-red-700 text-xs bg-red-50 p-2 rounded-lg border border-red-100"
}, R = /* @__PURE__ */ C({
  __name: "ImageUploader",
  props: {
    imageUploadApi: {},
    idx: {},
    currentVersion: {},
    merchantId: {},
    baseUrl: {}
  },
  emits: ["success", "clear"],
  setup(c, { emit: m }) {
    const o = c, x = m, b = v(null), a = v(null), { uploadProcess: p, isUploading: l, uploadError: n } = E(o.imageUploadApi), h = async (t) => {
      var U;
      const e = t.target, r = (U = e.files) == null ? void 0 : U[0];
      if (!r) return;
      const s = await p(r, o.idx);
      s && (a.value = s, x("success", { url: s, idx: o.idx })), e.value = "";
    }, d = v(!1), u = (t) => {
      if (t === "0") {
        a.value = null;
        return;
      }
      d.value = !0;
      const e = `${o.merchantId}-${o.idx}?t=${t}`, r = `${o.baseUrl}${e}`, s = new Image();
      s.src = r, s.onload = () => {
        a.value = r, d.value = !1;
      }, s.onerror = () => {
        a.value = null, d.value = !1;
      };
    };
    _(() => o.currentVersion, (t) => {
      u(t);
    }, { immediate: !0 });
    const y = async () => {
      var t, e;
      try {
        l.value = !0, n.value = null, await o.imageUploadApi.deleteImage(o.idx), a.value = "", x("clear", o.idx);
      } catch (r) {
        n.value = "刪除失敗: " + (((e = (t = r.response) == null ? void 0 : t.data) == null ? void 0 : e.message) || r.message), console.error("Delete error:", r);
      } finally {
        l.value = !1;
      }
    };
    return (t, e) => (g(), f("div", $, [
      i("input", {
        type: "file",
        ref_key: "fileInput",
        ref: b,
        class: "hidden",
        accept: "image/*",
        onChange: h
      }, null, 544),
      i("div", S, "Slot: " + k(c.idx), 1),
      a.value ? (g(), f("div", P, [
        i("img", {
          src: a.value,
          class: "w-full h-48 object-cover rounded-xl border border-gray-100 shadow-sm transition-opacity group-hover:opacity-90"
        }, null, 8, V),
        i("button", {
          onClick: y,
          class: "absolute -top-2 -right-2 bg-red-700 hover:bg-red-800 text-white w-6 h-6 rounded-full text-xs flex items-center justify-center shadow-lg transition-transform hover:scale-110",
          title: "刪除圖片"
        }, " ✕ "),
        i("div", {
          onClick: e[1] || (e[1] = (r) => {
            var s;
            return (s = b.value) == null ? void 0 : s.click();
          }),
          class: "absolute inset-0 flex items-center justify-center bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity cursor-pointer rounded-xl text-blue-700 text-sm font-bold"
        }, " 更換圖片 ")
      ])) : (g(), f("div", {
        key: 0,
        onClick: e[0] || (e[0] = (r) => {
          var s;
          return (s = b.value) == null ? void 0 : s.click();
        }),
        class: "cursor-pointer"
      }, [
        e[2] || (e[2] = i("div", { class: "text-blue-700 font-black text-4xl mb-2" }, "+", -1)),
        e[3] || (e[3] = i("p", { class: "text-gray-700 font-bold" }, "點擊上傳圖片", -1)),
        i("p", B, "Slot " + k(c.idx), 1)
      ])),
      w(l) ? (g(), f("div", A, " 處理中... ")) : I("", !0),
      w(n) ? (g(), f("div", D, k(w(n)), 1)) : I("", !0)
    ]));
  }
});
export {
  R as ImageUploader,
  E as useImageUpload
};
